import useGetAllShopEmailTemplatesSuspense from "@babackapp/private-api-client/client/use-get-all-shop-email-templates";
import { FormField } from "@babackapp/ui/components/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@babackapp/ui/components/select";
import { useWorkflowForm } from "../../context/workflows-editor-workflows-context";
import useCurrentShopSuspense from "../../hooks/use-current-shop-suspense";
import { useNodeFormPath } from "../../hooks/use-node-form-path";
import { useTrackingStatusMap } from "../trigger/use-tracking-status-list";
import { PanelContent } from "../../lib/panel/panel-content";
import { Switch } from "@babackapp/ui/components/switch";
import { isValidTrackingStatus } from "../trigger/utils";

export function PanelWebTemplate() {
  const form = useWorkflowForm();
  const { data: shop } = useCurrentShopSuspense();
  const { data: allTemplates } = useGetAllShopEmailTemplatesSuspense(shop.id);
  const templateFieldPath = useNodeFormPath("config.templateId");
  const statusFieldPath = useNodeFormPath("config.lockedToStatus");
  const trackingStatusMap = useTrackingStatusMap();

  const triggerStatus = form.watch(
    "workflow.trigger.data.config.trackingStatus",
  );

  if (!templateFieldPath) {
    return null;
  }

  // Get current workflow trigger status to use as default
  // const currentWorkflow = form.getValues("workflow");
  // const triggerNode = currentWorkflow?.trigger;

  const templates = allTemplates?.filter((template) => template.type === "web");

  return (
    <>
      <PanelContent title="Template">
        <FormField
          control={form.control}
          name={templateFieldPath}
          render={({ field }) => {
            const selectedTemplate = templates?.find(
              (template) => template.id === field.value,
            );

            return (
              <Select
                value={field.value as string}
                onValueChange={field.onChange}
              >
                <SelectTrigger className="w-[200px] h-8 text-xs">
                  <SelectValue>
                    {selectedTemplate?.title || "Default"}
                  </SelectValue>
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="null">
                    <div className="flex flex-col gap-1">
                      <span className="text-xs">Default</span>
                      <span className="text-[10px] text-muted-foreground">
                        Use default web template
                      </span>
                    </div>
                  </SelectItem>
                  {templates?.map((template) => (
                    <SelectItem key={template.id} value={template.id}>
                      <div className="flex flex-col gap-1">
                        <span className="text-xs">{template.title}</span>
                      </div>
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            );
          }}
        />
      </PanelContent>

      {statusFieldPath && isValidTrackingStatus(triggerStatus) && (
        <PanelContent
          title={`Seulement pour "${trackingStatusMap[triggerStatus]?.label ?? triggerStatus}"`}
          description="Si vous activez cette option, le template sera utilisé uniquement pour le statut du workflow et reviendra au template par défaut si le statut du workflow change."
        >
          <FormField
            control={form.control}
            name={statusFieldPath}
            render={({ field }) => {
              return (
                <Switch
                  checked={field.value === triggerStatus}
                  onCheckedChange={(value) =>
                    field.onChange(value ? triggerStatus : null)
                  }
                />
              );
            }}
          />
        </PanelContent>
      )}
    </>
  );
}
